import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { bubbleStyles } from '../../data/commonStyles';

type MessageTextWrapperProps = {
  isSingleLine: boolean;
  isUserMessage: boolean;
  isSystemMessage: boolean;
  isLiveAgentMessage?: boolean;
  showAgentNameTag?: boolean;
  shouldBreakWords: boolean;
  direction: 'rtl' | 'ltr';
  isLastSystemMessage?: boolean;
};

export const MessageTextWrapper = styled.div<MessageTextWrapperProps>`
  color: #000;
  line-height: 18px;
  font-size: 14px;
  font-weight: 400;
  text-align: ${({ direction }) => (direction === 'ltr' ? 'left' : 'right')};
  letter-spacing: 0.5px;
  word-break: ${({ shouldBreakWords }) => (shouldBreakWords ? 'break-all' : 'normal')};
  overflow-wrap: break-word;
  direction: ${({ direction }) => direction};
  background-color: ${({ isUserMessage, isSystemMessage, isLiveAgentMessage, theme }) => {
    if (isUserMessage) {
      return theme.colors.light;
    }
    if (isSystemMessage) {
      return 'transparent !important';
    }
    if (isLiveAgentMessage) {
      return '#D5E8A0 !important';
    }
    return '#fff';
  }};
  box-shadow: 0 0 2px 0 #0000001a;
  box-sizing: border-box;

  ${({ theme }) => css`
    @media (${theme.mediaMobile}) {
      line-height: 22px;
      font-size: 16px;
    }
  `}

  hr {
    margin: 20px 0;
    border-top: 1px solid #d2d2d2;
  }

  strong,
  b {
    font-weight: 500;
  }

  strong {
    font-weight: bold;
  }

  .spinner {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-width: 2px;
    border-radius: 50%;
    border-style: solid;
    border-color: #ccc;
    border-bottom-color: transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }

  li {
    margin-bottom: 30px;

    &:last-of-type {
      button {
        margin-bottom: 13px;
      }
    }
  }

  & > ol,
  & > ul {
    margin: 20px 0;
    padding-left: 10px;
  }

  .product-recommendations-list {
    padding-right: 20px;
    padding-left: 20px;
    list-style: decimal;

    ul {
      margin: 5px 0;
      padding-left: 17px;

      li {
        margin-bottom: 5px;
      }
    }
  }

  img {
    overflow: hidden;
  }

  .link-image {
    margin-top: 15px;
    width: auto;
    max-width: 100%;
    height: auto;
    border-radius: 10px;

    &:first-of-type {
      margin-top: 10px;
    }
  }

  a {
    color: #000;
    font-weight: 500;
    text-decoration: none;
    border-bottom: 0.5px solid #000;
  }

  p {
    margin-top: 0;
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 10px 0;
  }

  .left {
    h6 {
      margin: 0;
      line-height: 130%;
      font-size: 13px;
      font-weight: 500;
      text-overflow: ellipsis;
      overflow: hidden;
      letter-spacing: 0.13px;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    span {
      display: block;
      margin-top: 5px;
      font-size: 13px;
    }

    a {
      display: inline-block;
      margin-top: 10px;
      color: #000;
      line-height: 119%;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.14px;
      border-bottom: 1px solid #000;
    }
  }

  .right {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: center;
    margin-left: 10px;
    height: 87px;

    img {
      display: block;
      max-width: 100%;
    }
  }

  .product {
    padding-bottom: 10px;
    border-bottom: 1px solid #d2d2d2;
  }

  .product-recommendations-list .product {
    margin-right: -15px;
    margin-left: -15px;
  }

  ${bubbleStyles};

  ${({ isUserMessage, isSystemMessage, theme }) =>
    isUserMessage ? theme.messageText.user : isSystemMessage ? '' : theme.messageText.ml};

  ${({ theme, isUserMessage }) => css`
    @media (${theme.mediaMobile}) {
      ${isUserMessage ? theme.messageText.user.mobile : theme.messageText.ml.mobile}
    }
  `}

  ${({ isLiveAgentMessage }) =>
    isLiveAgentMessage &&
    css`
      color: #193b1d;
    `}

  ${({ showAgentNameTag }) =>
    showAgentNameTag &&
    css`
      border-top-left-radius: 0;
    `}
`;

export const ProcessingTimeWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  font-size: 10px;
  font-weight: 500;
  gap: 10px;
`;

export const ProcessingTime = styled.div`
  padding: 0 4px 2px;
  color: black;
  font-weight: bold;
  border: 1px solid #afafaf;
  border-radius: 4px;
`;
